import { PO_STATUSES } from "@/lib/constants";

const TONE_CLASSES = {
  slate:   "bg-slate-100 text-slate-700 hover:bg-slate-100",
  amber:   "bg-amber-100 text-amber-800 hover:bg-amber-100",
  blue:    "bg-blue-100 text-blue-800 hover:bg-blue-100",
  emerald: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
  violet:  "bg-violet-100 text-violet-800 hover:bg-violet-100",
  green:   "bg-green-100 text-green-800 hover:bg-green-100",
  red:     "bg-red-100 text-red-800 hover:bg-red-100",
  gray:    "bg-gray-100 text-gray-700 hover:bg-gray-100",
};

export function PoStatusBadge({ status, size = "default", ...rest }) {
  const cfg = PO_STATUSES.find((s) => s.value === status);
  const label = cfg?.label || status || "—";
  const cls = TONE_CLASSES[cfg?.tone] || TONE_CLASSES.slate;
  const sizeCls = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${cls} ${sizeCls}`}
      {...rest}
    >
      {label}
    </span>
  );
}
